"use client";
import { useState, cloneElement, Children, isValidElement, useEffect } from "react";
import { useMediaQuery } from "@/utils/use-media-stable";
import cl from "classnames";
import { Modal } from "@/components/Modal";
import IconCross from "../../assets/icons/i-cross.svg";
import IconqQr from "../../assets/icons/qr.svg";

import styles from "./ScanQr.module.css";

type Props = {
  
};

export const ScanQr = ({ 
  children
}: React.PropsWithChildren<Props>) => {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const [isOpenQR, setIsOpenQR] = useState(false);
  const [existFrameElement, setExistFrameElement] = useState(false);

  const handleOpenQR = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsOpenQR(true);
  };

  useEffect(() => {
    setExistFrameElement(!window.frameElement);
  }, []);

  return (
    <>
      <Modal
        isOpen={existFrameElement && isOpenQR}
        isDesktop
        overlayClassName={cl(
          "modal-overlay modal-overlay-blur",
          styles.modalOverlay
        )}
        className={cl("modal-content-fullscreen", styles.modalWrapper)}
        closeTimeoutMS={150}
      >
        <button
          className={styles.card_close}
          type="button"
          onClick={() => setIsOpenQR(false)}
        >
          <IconCross className={styles.card_close_icon} />
        </button>
        <div className={styles.root}>
          <IconqQr className={styles.qrIcon} />
        </div>
      </Modal>
      {children
        ? Children.map(children, (child) => {
            if (isValidElement(child)) {
              return cloneElement(child, {
                ...child.props,
                onClick: !isMobile ? handleOpenQR : undefined
              });
            }
            throw new Error(
              "QR: Child of carousel should be tag of ReactElement"
            );
          })
        : null}
    </>
  );
};
